import { render, staticRenderFns } from "./VInputDatePicker.vue?vue&type=template&id=472a85aa"
import script from "./VInputDatePicker.vue?vue&type=script&lang=js"
export * from "./VInputDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports